import {Pipe, PipeTransform, inject} from '@angular/core';
import {LanguageService} from "../services/language.service";
import {DatePipe} from "@angular/common";

@Pipe({
  name: 'timePast',
  standalone: true
})
export class TimePastPipe implements PipeTransform {
  private languageService: LanguageService = inject(LanguageService);
  private datePipe: DatePipe = inject(DatePipe);


  public transform(value: Date | string): string | null {
    const now = new Date();
    const inputDate = new Date(value);
    const diffInMilliseconds = now.getTime() - inputDate.getTime();
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));

    if (diffInMinutes < 1) return this.languageService.getTranslationByKey('RIGHTNOW');
    if (diffInMinutes < 2) return this.languageService.getTranslationByKey('AMINUTEAGO');
    if (diffInMinutes < 60) return this.languageService.getTranslationByKey('SOMEMINUTESAGO').replace('{SMA}', String(diffInMinutes));
    if (diffInHours < 2) return this.languageService.getTranslationByKey('AHOURAGO');
    if (diffInHours < 24) return this.languageService.getTranslationByKey('SOMEHOURSAGO').replace('{SHA}', String(diffInHours));

    return this.datePipe.transform(value, 'short');
  }

}
